<template>
    <div class="no_container" :style="{height, width, background}">
        <div class="no_wrapper">
            <img :src="require(`@i/no-data/no-data-${imgType}.svg`)" v-if="showImg" />
            <p class="text" v-if="text">{{$t('common.' + text)}}</p>
            <p class="text" v-else>{{$t('common.暂无数据')}}</p>
        </div>
    </div>
</template>

<script>
/**
 * ComponentName: 暂无数据
 * Created Date:2022/4/28
 * Author: shishuo·zhang
 * Modify: Nancy 2022/5/11
 * 组件说明：
 * showImg 是否展示图片，默认展示
 * eg:
 *  <cl-no-data img-type="file"></cl-no-data>
 */
export default {
    name: 'cl-no-data',
    props: {
        imgType: {
            type: String,
            default: 'default',
        },
        text: {
            type: String,
            default: '',
        },
        height: {
            type: String,
            default: '100%'
        },
        width: {
            type: String,
            default: '100%'
        },
        background: {
            type: String,
            default: 'transparent'
        },
        showImg: {
            type: Boolean,
            default: true
        }
    },
}
</script>

<style scoped>
.no_container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
}
.no_wrapper img {
    height: 131px;
    margin-bottom: 15px;
}
.no_wrapper .text {
    width: 100%;
    line-height: 20px;
    text-align: center;
    font-size: var(--font-14);
    color: #afafaf;
}
</style>
